import { Pipe, PipeTransform, inject } from '@angular/core';
import {
  TemplateMetadataContext,
  TemplateMetadataService,
} from '../../core/services/template-metadata.service';

/**
 * Resolves {{checkpoint.title}}-style placeholders against the current
 * checkpoint/instance/user/team metadata.
 *
 * Usage:
 *   {{ content | templateMetadata:templateContext }}
 */
@Pipe({
  name: 'templateMetadata',
  pure: true,
  standalone: true,
})
export class TemplateMetadataPipe implements PipeTransform {
  private templateMetadataService = inject(TemplateMetadataService);

  transform(content: string, context: TemplateMetadataContext | null | undefined): string {
    return this.templateMetadataService.render(content, context);
  }
}
